module.exports = __webpack_public_path__ + "static/media/bg-1.73f3f19.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/pc/vedio/bg-1.webm
// module id = Y7CA
// module chunks = 13